import { connect, MapStateToProps } from 'react-redux';
import { Props } from './BillingCyclePopup';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getPackages,
  getGiftUser,
  getSale,
  getCurrentCoreSubscription,
} from '../../../../redux/packagePicker/selectors';

export type StateProps = Pick<
  Props,
  | 'filteredPackages'
  | 'sale'
  | 'alreadyHasSubscription'
  | 'hasPrepaidSubscription'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  ownProps
) => {
  return {
    filteredPackages: getPackages(state)?.filter(p =>
      ownProps.selectedPackage?.includes(p.subproductId)
    ),
    giftUser: getGiftUser(state),
    sale: getSale(state),
    alreadyHasSubscription: ownProps.giftUser
      ? false
      : getCurrentUserHasCore(state),
    hasPrepaidSubscription: ownProps.giftUser
      ? false
      : getCurrentCoreSubscription(state)?.isUpgradable
      ? true
      : false,
  };
};

export default connect(mapStateToProps);
